import classNames from 'classnames';
import Txt from '../Txt';
import styles from './AppVersion.module.scss';

const version = process.env.REACT_APP_VERSION;

/**
 * AppVersion
 *
 * @return {JSX.Element}
 */
const AppVersion = ({ className }) => {
  return (
    <Txt
      className={classNames(
        styles.AppVersion,
        className,
        `${AppVersion.displayName}`
      )}
    >
      {version ? `v${version}` : 'unknown'}
    </Txt>
  );
};

AppVersion.displayName = 'AppVersion';

export default AppVersion;
